<template>
  <div id="search-form">
    <form @submit.prevent class="container d-flex flex-column">
      <div class="row mb-3">
        <fieldset class="search col-md-3">
          <legend>{{ $t('form.search.legend') }}</legend>
          <ncs-elements-type/>
        </fieldset>
        <fieldset class="result col-md-9">
          <legend>{{ $t('form.result.legend') }}</legend>
          <div class="row">
            <div class="col-md-3">
              <ncs-result-type/>
            </div>
            <div class="col-md-6">
              <ncs-order-selector/>
            </div>
            <div class="col-md-3">
              <ncs-page-size-selector/>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="row mb-3">
        <fieldset class="sensibility col-md-3">
          <legend>{{ $t('form.sensibility.legend') }}</legend>
          <div class="row">
            <div class="col-lg-6">
              <ncs-sensitivity name="case"/>
              <ncs-sensitivity name="and_et"/>
            </div>
            <div class="col-lg-6">
              <ncs-sensitivity name="ij"/>
              <ncs-sensitivity name="uv"/>
            </div>
          </div>
        </fieldset>
        <fieldset class="filters col-md-9">
          <legend>{{ $t('form.filters.legend') }}</legend>
          <div class="row">
            <div class="col-md-3">
              <ncs-select id="documents.otorgante"/>
            </div>
            <div class="col-md-3">
              <ncs-select id="documents.bibliografia_titulo"/>
            </div>
            <div class="col-md-3">
              <ncs-select id="documents.bibliografia_autor"/>
            </div>
            <div class="col-md-3">
              <ncs-select id="documents.bibliografia_editorial"/>
            </div>
            <div class="col-md-3">
              <ncs-filter id="documents.ano_desde" type="number" :input-props="{ min: 1230, max: 1500, step: 1}"/>
            </div>
            <div class="col-md-3">
              <ncs-filter id="documents.ano_hasta" type="number" :input-props="{ min: 1230, max: 1500, step: 1}"/>
            </div>
          </div>
        </fieldset>
      </div>
      <ncs-element-section/>
      <div class="btn-group align-self-end mt-3">
        <ncs-download-button/>
        <ncs-back-button/>
        <button type="button" class="btn btn-primary" @click="reload()">
          {{ $t('reset') }}
        </button>
        <ncs-search-button/>
      </div>
    </form>
    <ncs-result>
      <ncs-frequency-result/>
      <ncs-full-frequency-result/>
      <ncs-kwic-result/>
      <ncs-context-result/>
    </ncs-result>
  </div>
</template>
<script lang="ts" setup>
import { onMounted } from 'vue'
import { initialize } from 'ncs'

onMounted(async () => await initialize())
const reload = () => location.reload()
</script>
